import { render, staticRenderFns } from "./Vite-sub.vue?vue&type=template&id=182eaa9e&scoped=true"
import script from "./Vite-sub.vue?vue&type=script&lang=js"
export * from "./Vite-sub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_65179a06be82c71d607b9dd0dd22b0bf/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182eaa9e",
  null
  
)

export default component.exports